import React from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody, Box, Typography } from '@mui/material';

/**
 * ScoreBoard
 * - props: playerAName, playerBName, scoreA, scoreB, history (array of {who, pts, reason})
 */
export default function ScoreBoard({ playerAName, playerBName, scoreA, scoreB, history = [] }) {
  return (
    <Box>
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 1 }}>
        <Typography variant="h6">{playerAName || 'Joueur 1'} — {scoreA}</Typography>
        <Typography variant="h6">:</Typography>
        <Typography variant="h6">{scoreB} — {playerBName || 'Joueur 2'}</Typography>
      </Box>

      <Table size="small" aria-label="historique">
        <TableHead>
          <TableRow>
            <TableCell>Chrono</TableCell>
            <TableCell>Qui</TableCell>
            <TableCell>Détails</TableCell>
            <TableCell>Pts</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {history.map((h, i) => (
            <TableRow key={i}>
              <TableCell>{h.time || ''}</TableCell>
              <TableCell>{h.who === 'A' ? playerAName || 'J1' : playerBName || 'J2'}</TableCell>
              <TableCell>{h.reason || ''}</TableCell>
              <TableCell>{h.pts}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}